import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m18 22-3-3 3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m6 2 3 3-3 3", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "SwitchCamera";
const SwitchCamera = memo(themed(Icon));
export {
  SwitchCamera
};
//# sourceMappingURL=switch-camera.js.map
